import { css } from '@emotion/react'

import { zIndex } from '@twistopayments/design-system/styles'

export const errorModal = css`
  z-index: ${zIndex.errorModal};
`
